/**
 * List of linked resources (acf.url_links).
 */

import Link from "next/link";
import { OpsiHtmlContent } from "../utils/OpsiHtmlContent";
import {
  asArray,
  hasHtmlContent,
  OPSI_PART_SPACING,
  OPSI_EXTERNAL_LINK_PROPS,
  resolveOpsiUrl,
} from "../utils/opsiHelpers";

const OPSI_LINKS_ACCENT = "#993189";
const OPSI_LINKS_BG = "#993189";
const OPSI_LINKS_BORDER = "rgba(153, 49, 137, 0.28)";

export const OpsiUrlLinks = ({
  data,
  className = `opsi-url-links ${OPSI_PART_SPACING}`,
}) => {
  const links = asArray(data?.url_link).filter((link) =>
    hasHtmlContent(link?.url_text),
  );
  const header = data?.header ?? "";

  if (!links.length && !hasHtmlContent(header)) {
    return null;
  }

  return (
    <section
      className={`${className} opsi-url-links__panel rounded-[20px] px-8 py-8 md:px-10 md:py-10`}
      style={{ backgroundColor: OPSI_LINKS_BG }}
      data-opsi-part="url-links"
    >
      {hasHtmlContent(header) ? (
        <OpsiHtmlContent
          html={header}
          as="h2"
          className="opsi-url-links__header !m-0 !p-0 !text-[1.5rem] !font-bold !text-[#fff] md:!text-[1.75rem] [&_*]:!m-0 [&_*]:!p-0 [&_*]:!text-[#fff]"
        />
      ) : null}

      {links.length ? (
        <ul
          className={`opsi-url-links__list !m-0 !list-none !p-0 ${
            hasHtmlContent(header) ? "!mt-6 md:!mt-8" : ""
          }`}
        >
          {links.map((link, index) => {
            const href = resolveOpsiUrl(link?.button?.button_link);
            const label = link?.url_text || "Link";
            const buttonText = link?.button?.button_text || "View";

            return (
              <li
                key={`${label}-${index}`}
                className="opsi-url-links__item flex items-center justify-between gap-6 py-5 md:py-6"
              >
                <span className="opsi-url-links__text min-w-0 flex-1 !text-[1rem] !font-medium !leading-normal !text-[#fff] md:!text-[1.125rem]">
                  {label}
                </span>

                {href ? (
                  <Link
                    href={href}
                    {...OPSI_EXTERNAL_LINK_PROPS}
                    className="opsi-view-pill-button shrink-0 transition hover:opacity-90 !bg-[#fff]"

                  >
                    <span className="opsi-view-pill-button__label !text-[#993189]">{buttonText}</span>
                  </Link>
                ) : (
                  <span
                    className="opsi-view-pill-button shrink-0 cursor-default opacity-50"
                    style={{ backgroundColor: OPSI_LINKS_ACCENT }}
                    aria-disabled="true"
                  >
                    <span className="opsi-view-pill-button__label !text-[#fff] !bg-[#993189]">{buttonText}</span>
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      ) : null}
    </section>
  );
};
